/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDutyScheduleRequest,
  DutyScheduleCounselorOptionResponse,
  DutyScheduleDetailResponse,
  DutyScheduleDistributionSummaryResponse,
  DutyScheduleResponse,
  ProblemDetails,
  RecalculateDutyScheduleRequest,
  ReleaseDutyScheduleResponse,
  SaveDutyScheduleAssignmentsRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CreateDutyScheduleRequestFromJSON,
    CreateDutyScheduleRequestToJSON,
    DutyScheduleCounselorOptionResponseFromJSON,
    DutyScheduleCounselorOptionResponseToJSON,
    DutyScheduleDetailResponseFromJSON,
    DutyScheduleDetailResponseToJSON,
    DutyScheduleDistributionSummaryResponseFromJSON,
    DutyScheduleDistributionSummaryResponseToJSON,
    DutyScheduleResponseFromJSON,
    DutyScheduleResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RecalculateDutyScheduleRequestFromJSON,
    RecalculateDutyScheduleRequestToJSON,
    ReleaseDutyScheduleResponseFromJSON,
    ReleaseDutyScheduleResponseToJSON,
    SaveDutyScheduleAssignmentsRequestFromJSON,
    SaveDutyScheduleAssignmentsRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateDutyScheduleOperationRequest {
    createDutyScheduleRequest: CreateDutyScheduleRequest;
}

export interface DeleteDutyScheduleRequest {
    id: string;
}

export interface GetAllDutySchedulesRequest {
    includePast?: boolean;
}

export interface GetDutyScheduleByIdRequest {
    id: string;
}

export interface GetDutyScheduleDistributionSummaryRequest {
    id: string;
}

export interface RecalculateDutyScheduleOperationRequest {
    id: string;
    recalculateDutyScheduleRequest: RecalculateDutyScheduleRequest;
}

export interface ReleaseDutyScheduleRequest {
    id: string;
}

export interface SaveDutyScheduleAssignmentsOperationRequest {
    id: string;
    saveDutyScheduleAssignmentsRequest: SaveDutyScheduleAssignmentsRequest;
}

/**
 * DutySchedulesApi - interface
 * 
 * @export
 * @interface DutySchedulesApiInterface
 */
export interface DutySchedulesApiInterface {
    /**
     * 
     * @param {CreateDutyScheduleRequest} createDutyScheduleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DutySchedulesApiInterface
     */
    createDutyScheduleRaw(requestParameters: CreateDutyScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleResponse>>;

    /**
     */
    createDutySchedule(requestParameters: CreateDutyScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DutySchedulesApiInterface
     */
    deleteDutyScheduleRaw(requestParameters: DeleteDutyScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteDutySchedule(requestParameters: DeleteDutyScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {boolean} [includePast] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DutySchedulesApiInterface
     */
    getAllDutySchedulesRaw(requestParameters: GetAllDutySchedulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DutyScheduleResponse>>>;

    /**
     */
    getAllDutySchedules(requestParameters: GetAllDutySchedulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DutyScheduleResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DutySchedulesApiInterface
     */
    getDutyScheduleByIdRaw(requestParameters: GetDutyScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleDetailResponse>>;

    /**
     */
    getDutyScheduleById(requestParameters: GetDutyScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleDetailResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DutySchedulesApiInterface
     */
    getDutyScheduleCounselorOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DutyScheduleCounselorOptionResponse>>>;

    /**
     */
    getDutyScheduleCounselorOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DutyScheduleCounselorOptionResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DutySchedulesApiInterface
     */
    getDutyScheduleDistributionSummaryRaw(requestParameters: GetDutyScheduleDistributionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleDistributionSummaryResponse>>;

    /**
     */
    getDutyScheduleDistributionSummary(requestParameters: GetDutyScheduleDistributionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleDistributionSummaryResponse>;

    /**
     * 
     * @param {string} id 
     * @param {RecalculateDutyScheduleRequest} recalculateDutyScheduleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DutySchedulesApiInterface
     */
    recalculateDutyScheduleRaw(requestParameters: RecalculateDutyScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleResponse>>;

    /**
     */
    recalculateDutySchedule(requestParameters: RecalculateDutyScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DutySchedulesApiInterface
     */
    releaseDutyScheduleRaw(requestParameters: ReleaseDutyScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReleaseDutyScheduleResponse>>;

    /**
     */
    releaseDutySchedule(requestParameters: ReleaseDutyScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReleaseDutyScheduleResponse>;

    /**
     * 
     * @param {string} id 
     * @param {SaveDutyScheduleAssignmentsRequest} saveDutyScheduleAssignmentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DutySchedulesApiInterface
     */
    saveDutyScheduleAssignmentsRaw(requestParameters: SaveDutyScheduleAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleDetailResponse>>;

    /**
     */
    saveDutyScheduleAssignments(requestParameters: SaveDutyScheduleAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleDetailResponse>;

}

/**
 * 
 */
export class DutySchedulesApi extends runtime.BaseAPI implements DutySchedulesApiInterface {

    /**
     */
    async createDutyScheduleRaw(requestParameters: CreateDutyScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleResponse>> {
        if (requestParameters['createDutyScheduleRequest'] == null) {
            throw new runtime.RequiredError(
                'createDutyScheduleRequest',
                'Required parameter "createDutyScheduleRequest" was null or undefined when calling createDutySchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/duty-schedules`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDutyScheduleRequestToJSON(requestParameters['createDutyScheduleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DutyScheduleResponseFromJSON(jsonValue));
    }

    /**
     */
    async createDutySchedule(requestParameters: CreateDutyScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleResponse> {
        const response = await this.createDutyScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteDutyScheduleRaw(requestParameters: DeleteDutyScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteDutySchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/duty-schedules/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDutySchedule(requestParameters: DeleteDutyScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDutyScheduleRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllDutySchedulesRaw(requestParameters: GetAllDutySchedulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DutyScheduleResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['includePast'] != null) {
            queryParameters['includePast'] = requestParameters['includePast'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/duty-schedules`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DutyScheduleResponseFromJSON));
    }

    /**
     */
    async getAllDutySchedules(requestParameters: GetAllDutySchedulesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DutyScheduleResponse>> {
        const response = await this.getAllDutySchedulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDutyScheduleByIdRaw(requestParameters: GetDutyScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleDetailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDutyScheduleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/duty-schedules/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DutyScheduleDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDutyScheduleById(requestParameters: GetDutyScheduleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleDetailResponse> {
        const response = await this.getDutyScheduleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDutyScheduleCounselorOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DutyScheduleCounselorOptionResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/duty-schedules/counselor-options`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DutyScheduleCounselorOptionResponseFromJSON));
    }

    /**
     */
    async getDutyScheduleCounselorOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DutyScheduleCounselorOptionResponse>> {
        const response = await this.getDutyScheduleCounselorOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getDutyScheduleDistributionSummaryRaw(requestParameters: GetDutyScheduleDistributionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleDistributionSummaryResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDutyScheduleDistributionSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/duty-schedules/{id}/distribution`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DutyScheduleDistributionSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDutyScheduleDistributionSummary(requestParameters: GetDutyScheduleDistributionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleDistributionSummaryResponse> {
        const response = await this.getDutyScheduleDistributionSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async recalculateDutyScheduleRaw(requestParameters: RecalculateDutyScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling recalculateDutySchedule().'
            );
        }

        if (requestParameters['recalculateDutyScheduleRequest'] == null) {
            throw new runtime.RequiredError(
                'recalculateDutyScheduleRequest',
                'Required parameter "recalculateDutyScheduleRequest" was null or undefined when calling recalculateDutySchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/duty-schedules/{id}/recalculate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RecalculateDutyScheduleRequestToJSON(requestParameters['recalculateDutyScheduleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DutyScheduleResponseFromJSON(jsonValue));
    }

    /**
     */
    async recalculateDutySchedule(requestParameters: RecalculateDutyScheduleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleResponse> {
        const response = await this.recalculateDutyScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async releaseDutyScheduleRaw(requestParameters: ReleaseDutyScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReleaseDutyScheduleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling releaseDutySchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/duty-schedules/{id}/release`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReleaseDutyScheduleResponseFromJSON(jsonValue));
    }

    /**
     */
    async releaseDutySchedule(requestParameters: ReleaseDutyScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReleaseDutyScheduleResponse> {
        const response = await this.releaseDutyScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveDutyScheduleAssignmentsRaw(requestParameters: SaveDutyScheduleAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DutyScheduleDetailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling saveDutyScheduleAssignments().'
            );
        }

        if (requestParameters['saveDutyScheduleAssignmentsRequest'] == null) {
            throw new runtime.RequiredError(
                'saveDutyScheduleAssignmentsRequest',
                'Required parameter "saveDutyScheduleAssignmentsRequest" was null or undefined when calling saveDutyScheduleAssignments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/duty-schedules/{id}/assignments`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveDutyScheduleAssignmentsRequestToJSON(requestParameters['saveDutyScheduleAssignmentsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DutyScheduleDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveDutyScheduleAssignments(requestParameters: SaveDutyScheduleAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DutyScheduleDetailResponse> {
        const response = await this.saveDutyScheduleAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
